import React from "react";
import {
  facebook_icon,
  instagram_icon,
  linkedin_icon,
  tiktok_icon,
  twitter_icon,
  youtube_icon,
} from "../../../../assets";
import TiktokIcon from "../../../../assets/icon/TiktokIcon";

function SocialLinks({ data, custom_class = "" }) {
  return (
    <>
      <div className={"social-links-container" + ` ${custom_class}`}>
        {data?.social_links?.facebook && (
          <a href={data.social_links.facebook} target="_blank">
            <img
              className="social-icon"
              src={facebook_icon}
              alt="facebook_icon"
            />
          </a>
        )}
        {data?.social_links?.instagram && (
          <a href={data.social_links.instagram} target="_blank">
            <img
              className="social-icon"
              src={instagram_icon}
              alt="facebook_icon"
            />
          </a>
        )}
        {data?.social_links?.tiktok_link && (
          <a href={data.social_links.tiktok_link} target="_blank">
            <img className="social-icon" src={tiktok_icon} alt="tiktok_icon" />
          </a>
        )}
        {data?.social_links?.linkedin && (
          <a href={data.social_links.linkedin} target="_blank">
            <img
              className="social-icon"
              src={linkedin_icon}
              alt="facebook_icon"
            />
          </a>
        )}
        {data?.social_links?.twitter && (
          <a href={data.social_links.twitter} target="_blank">
            <img
              className="social-icon"
              src={twitter_icon}
              alt="facebook_icon"
            />
          </a>
        )}
        {data?.social_links?.youtube && (
          <a href={data.social_links.youtube} target="_blank">
            <img
              className="social-icon"
              src={youtube_icon}
              alt="facebook_icon"
            />
          </a>
        )}
      </div>
    </>
  );
}

export default SocialLinks;
